import { Box } from '@mui/material';
import { TabPanel } from '@mui/lab';
import React from 'react';
import ChargesLN from 'views/orders/charges-accounting/charges-ln/charges-ln';

export const ChargesLNTabContent = () => {
  return (
    <TabPanel value="L-N" style={{ padding: '16px', marginTop: '1rem' }}>
      <Box>
        <ChargesLN showHeaderAndContainer={false} />
      </Box>
    </TabPanel>
  );
};
